import React, { useState, useCallback, useEffect, useRef } from 'react';
// import GoogleMapReact from 'google-map-react';
import useApi from '../../api/useApi';
import '../../scrollbar.css';
import moment from 'moment';

function index({ gatewayData, handleClose }) {
  console.log(gatewayData);
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const [stats, setStats] = useState([]);
  const formModel = {
    q: '',
  };
  const [formData, setFormData] = useState(formModel);
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const [gateways, getwaysData] = useApi();
  const [gateway, setGateways] = useState([]);
  let gatewayURL = '/zone/data?';

  useEffect(() => {
    for (let i = 0; i < gatewayData.gateways.length; i++) gatewayURL += `blegw[]=${gatewayData.gateways[i].deviceId}&`;
    user && getwaysData(gatewayURL, 'GET');
  }, [gatewayData]);

  useEffect(() => {
    if (gateways.isError) {
      setGateways([]);
    }
    if (!gateways.isLoading && !gateways.isError && gateways.data) {
      if (gateways.data.length > 0) {
        setGateways(gateways.data);
        setStats(gateways.data);
      }
    } else {
      const gateData = gatewayData.gateways.map((x) => {
        return {
          blegwId: x.deviceId,
          data: [],
        };
      });
      setGateways(gateData);
    }
  }, [gateways.isLoading, gateways.isError, gateways.data]);

  useEffect(() => {
    if (stats.length <= 0) {
      return;
    }

    let z = stats;
    if (formData.q) {
      z = z.filter((x) => {
        const normalizedQuery = formData.q.toLowerCase();
        const _data = x.data.filter((y, idx) => {
          if (y.assetName !== null) {
            return (
              y.deviceId.toLowerCase().indexOf(normalizedQuery) >= 0 ||
              y.assetName.toLowerCase().indexOf(normalizedQuery) >= 0
            );
          }
        });

        const obj = {
          blegwId: x.blegwId,
          data: _data,
        };
        const arr = [obj];
        setGateways(arr);
      });
    }
  }, [stats, formData]);

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    const currentOffset = moment().utcOffset();

    const utc_time = moment(_date).utc(currentOffset);
    return moment(utc_time).fromNow();
  };

  const getDiff = (ts) => {
    return new Date().getTime() - new Date(ts * 1000).getTime() >= 3600000;
  };

  const downloadReport = () => {
    const rows = [];
    const headerRows = ['ZONE', 'ASSET', 'DEVICE', 'GATEWAY', 'SENSOR VALUES', 'LAST_REPORTED'];
    rows.push(headerRows);
    // iterate through rows of table
    for (let i = 0, row; (row = gateways.data.zoneData[i]); i++) {
      // rows would be accessed using the "row" variable assigned in the for loop
      // Get each cell value/column from the row
      const column0 = gatewayData.location || '';
      const column1 = row?.assetName || '';
      const column2 = row?.deviceId || '';
      const column3 = row?.blegwId || '';
      const column4 = row?.tm ? `${parseFloat(row?.tm).toFixed(2)} ` + '\u00b0' + 'C' : '';
      const column5 = row.ts !== null ? getTimeoffset(row.ts) : '';

      /* add a new records in the array */
      rows.push([column0, column1, column2, column3, column4, column5]);
    }
    let csvContent = 'data:text/csv;charset=utf-8,';

    /* add the column delimiter as comma(,) and each row splitted by new line character (\n) */
    rows.forEach(function (rowArray) {
      const row = rowArray.join(',');
      csvContent += `${row}\r\n`;
    });
    /* create a hidden <a> DOM node and set its download attribute */
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', 'zone.csv');
    document.body.appendChild(link);
    /* download the data file  */
    link.click();
  };

  return (
    <div className="flex justify-center items-center z-20 zone_width">
      <div className="block lg:flex mt-1 lg:mt-0 absolute h-8 right-0 -top-10">
        <button
          className="mt-1 back_zone lg:mt-0 w-28 lg:w-max border px-3 py-1  text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-8 bg-btnBg text-white rounded-md"
          onClick={handleClose}
        >
          Back
        </button>
        <button
          className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 h-8 rounded-md text-xs mx-3 font-bold focus:outline-none flex justify-center items-center bg-btnBg text-white button_mobile2 "
          onClick={downloadReport}
        >
          Report
          <img src="assets/img/download.svg" className="h-3 ml-2 transform rotate-180" alt="" />
        </button>
        <button
          className="mt-1 show_map lg:mt-0 w-28 lg:w-max border px-3 py-1  text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-8 bg-btnBg text-white rounded-md"
          onClick={handleClose}
        >
          Show Map
        </button>
        <div className="mt-1 lg:mt-0 w-full lg:w-max border bg-transparent px-4 py-1 rounded-3xl ml-3 flex justify-between items-center right-44 search_zone ">
          <input
            type="text"
            placeholder="Search Asset/Device"
            autoComplete="off"
            className="text-textBox text-xs bg-transparent focus:outline-none"
            value={formData.q}
            name="q"
            onChange={handleInputChange}
            style={{ borderColor: '#e6e6e6' }}
          />
          <img src="assets/img/Search.png" className="h-4 ml-2 " alt="" />
        </div>
      </div>
      <div className="w-full block ">
        <div className="bg-white zone_div1 ">
          <p className="text-md font-bold py-3 w-11/12 m-auto zone_div bg-white ">
            Gateway(s) in zone {gatewayData.location}
          </p>
          <div className="bg-primary w-11/12 m-auto flex text-white zone_div bg-white">
            <div className="px-6 flex w-full py-3">
              <div className="text-left text-xs w-2/4 ">GATEWAY</div>
              <div className="text-left text-xs w-1/4 flex">
                {' '}
                <img src="assets/img/Antenna.png" className="w-4 mr-1" alt="" />
                RSSI
              </div>
              <div className="text-left text-xs w-1/4 flex">
                {' '}
                <img src="assets/img/Battery.png" className="w-4 mr-1 transform -rotate-90" alt="" />
                BATTERY
              </div>
              <div className="text-left text-xs w-1/4">STATUS</div>
            </div>
          </div>
          {gateway.length !== 0 ? (
            <div className="pb-1 w-11/12 m-auto bg-white">
              {gateway
                ? gateway.map((item) => {
                    // let bat = <img src="assets/img/Battery.png" className="w-4 mr-2 transform -rotate-90" alt="" />;
                    // let rssi = <img src="assets/img/Antenna.png" className="w-4 mr-2" alt="" />;
                    return (
                      <div
                        className="my-2 px-6 flex py-2.5 text-role font-medium
                        relative"
                        style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                      >
                        <div className="flex text-xs w-2/4">{item?.blegwId}</div>
                        <div className="flex text-xs w-1/4">
                          {gateways?.data?.shadows[item?.blegwId]?.rssi
                            ? `${gateways?.data?.shadows[item?.blegwId]?.rssi} dBm`
                            : ''}
                        </div>
                        <div className="flex text-xs w-1/4 pl-1">
                          {gateways?.data?.shadows[item?.blegwId]?.vbat
                            ? gateways?.data?.shadows[item?.blegwId]?.vbat > 100
                              ? `${gateways?.data?.shadows[item?.blegwId]?.vbat} mV`
                              : `${gateways?.data?.shadows[item?.blegwId]?.vbat} %`
                            : ''}
                        </div>
                        <div className="flex text-xs w-1/4">
                          {gateways?.data?.shadows[item?.blegwId]?.ts === undefined ? null : getDiff(
                              gateways?.data?.shadows[item?.blegwId]?.ts
                            ) ? (
                            <p style={{ color: 'red' }}>Offline</p>
                          ) : (
                            <p style={{ color: 'green' }}>Online</p>
                          )}
                        </div>
                      </div>
                    );
                  })
                : null}
            </div>
          ) : (
            <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
          )}
        </div>
        <div
          className="bg-white max-w-screen-xl mx-auto w-auto w-4 max-w-screen-xl mx-auto"
          style={{
            // boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
            // borderRadius: '6px',
            // height: '40vh',
            overflow: 'auto',
          }}
        >
          <div className="w-full absolute bg-white">
            <p className="text-md font-bold py-3 w-11/12 m-auto zone_div2 bg-white">
              Last reported devices in zone {gatewayData.location}
            </p>
            <div className="bg-primary w-11/12 m-auto flex text-white zone_div2">
              <div className="px-6 flex w-full py-3">
                <div className="text-left text-xs w-2/12">ASSET</div>
                <div className="text-left text-xs w-2/12">DEVICE</div>
                <div className="text-left text-xs w-2/12">GATEWAY</div>
                <div className="text-left text-xs w-2/12">SENSOR VALUES</div>
                <div className="text-left text-xs w-2/12">RSSI</div>
                <div className="text-left text-xs w-2/12">LAST REPORTED</div>
              </div>
            </div>
            {!gateways.isLoading ? (
              <div className="pb-1 hideScroll w-11/12 m-auto zone_div2" style={{ overflow: 'auto', height: '41vh' }}>
                {gateways.data && gateways.data.zoneData
                  ? gateways.data.zoneData.map((itm) => (
                      <div
                        className="my-2 px-6 flex py-2.5 text-role font-medium
                          relative"
                        style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                      >
                        <div className=" flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                          {itm?.assetName}
                        </div>
                        <div className=" flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                          {itm?.deviceId}
                        </div>
                        <div className="flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                          {itm?.blegwId}
                        </div>
                        <div className="flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                          {itm?.tm ? <img src="assets/img/temperature.png" className="w-2 mt-1 mr-2" alt="" /> : null}
                          {itm?.tm ? `${parseFloat(itm?.tm).toFixed(2)} ` + '\u00b0' + 'C' : null}
                        </div>
                        <div className="flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                          {itm?.rssi + ' dBm'}
                        </div>
                        <div className="flex items-center text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs w-2/12">
                          {itm.ts !== null ? getTimeoffset(itm.ts) : 'N/A'}
                        </div>
                      </div>
                    ))
                  : null}
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default index;
